import { render } from "./FileConfigSnippet.vue?vue&type=template&id=6be0a600&scoped=true"
import script from "./FileConfigSnippet.vue?vue&type=script&lang=js"
export * from "./FileConfigSnippet.vue?vue&type=script&lang=js"

import "./FileConfigSnippet.vue?vue&type=style&index=0&id=6be0a600&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6be0a600"]])

export default __exports__